import { render } from "./AgentLanding.vue?vue&type=template&id=aca8572c&scoped=true"
import script from "./AgentLanding.vue?vue&type=script&lang=js"
export * from "./AgentLanding.vue?vue&type=script&lang=js"

import "./AgentLanding.vue?vue&type=style&index=0&id=aca8572c&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca8572c"]])

export default __exports__